import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbAmbiente } from 'app/abstract/full-pages/customs/ambiente/ambiente.abstract';

@Injectable({
  providedIn: 'root'
})
export class AmbienteService extends AbAmbiente {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllAmbientes(): Observable<any> {
    return this.get("areacomum/all");
  }

  public getAllAmbientesPermitePrevisaoVisita(excluirNaoAgendaveis): Observable<any> {
    if (excluirNaoAgendaveis)
      return this.get("areas/lista_convidados");
    return this.get("areas/pessoa_logada_areas");
  }

}
